/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S7_P1Inputs */

const tr_iade_iptal_s7_p1 = /** @type {(inputs: Iade_Iptal_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik, seçilen süre için peşin ödenir ve süre sonunda kendiliğinden sona erer. Otomatik yenileme yapılmaz ve karttan otomatik tahsilat gerçekleştirilmez.`)
};

const en_iade_iptal_s7_p1 = /** @type {(inputs: Iade_Iptal_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The subscription is paid in advance for the chosen term and ends by itself at the end of the term. There is no automatic renewal and no automatic card charge.`)
};

const de_iade_iptal_s7_p1 = /** @type {(inputs: Iade_Iptal_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Abonnement wird für die gewählte Laufzeit im Voraus bezahlt und endet mit Ablauf der Laufzeit von selbst. Es gibt keine automatische Verlängerung und keinen automatischen Karteneinzug.`)
};

const ru_iade_iptal_s7_p1 = /** @type {(inputs: Iade_Iptal_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписка оплачивается заранее за выбранный срок и по окончании срока прекращается сама. Автоматического продления и автоматического списания с карты не производится.`)
};

/**
* | output |
* | --- |
* | "The subscription is paid in advance for the chosen term and ends by itself at the end of the term. There is no automatic renewal and no automatic card charge." |
*
* @param {Iade_Iptal_S7_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s7_p1 = /** @type {((inputs?: Iade_Iptal_S7_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S7_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s7_p1(inputs)
	if (locale === "de") return de_iade_iptal_s7_p1(inputs)
	if (locale === "ru") return ru_iade_iptal_s7_p1(inputs)
	return tr_iade_iptal_s7_p1(inputs)
});